import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "@src/store/rootState";
import {
  DrawerState,
  DrawerType,
  IDrawerState,
  ModifySubscriptionDrawerState,
} from "@src/store/types/drawers";

const initialState = {
  modifySubscription: {
    type: "modifySubscription",
    open: false,
    agencyId: null,
    orgs: [],
    orgId: "",
    stripeSubscriptionId: "",
    subscriptionLinkIds: [""],
    phaseIndex: 0,
    usages: null,
  } as ModifySubscriptionDrawerState,
} as IDrawerState;

const slice = createSlice({
  name: "drawers",
  initialState,
  reducers: (create) => ({
    openDrawer: create.reducer<DrawerState>((state, action) => {
      state[action.payload.type] = action.payload;
    }),
    closeDrawer: create.reducer<DrawerType>((state, action) => {
      delete state[action.payload];
    }),
  }),
});

export const { openDrawer, closeDrawer } = slice.actions;
export const setDrawer = slice.actions.openDrawer;

// The modify-subscription drawer is kept in state with `open: false` rather than
// deleted, so `ContentWrapper` runs its cleanup branch (resets orgs/usages/ready).
// Use this for every close path so they behave identically.
export const closeModifySubscriptionDrawer = () =>
  setDrawer({
    type: "modifySubscription",
    open: false,
    agencyId: null,
    orgs: [],
    stripeSubscriptionId: "",
    subscriptionLinkIds: [""],
    usages: null,
  });

export const getDrawer =
  <T extends DrawerType>(type: T) =>
  (state: RootState) =>
    state.drawers[type] as Extract<DrawerState, { type: T }> | undefined;

export const isDrawerOpen = (type: DrawerType) => (state: RootState) =>
  state.drawers[type] !== undefined;

export const drawersReducer = slice.reducer;
